export const removeAccents = str => {
    return str?.normalize("NFD")?.replace(/[\u0300-\u036f]/g, "");
}

export const findMostSimilar = (searchArray, searched, minScore, compareFunction) => {
    const searchArrayCopy = searchArray.map(v => ({...v}));
    let maxScore = 0.0;
    let found = null;
    searchArrayCopy.forEach(v => {
        v.score = compareFunction(v, searched)
        if (v.score > maxScore && v.score >= minScore) {
            maxScore = v.score;
            found = v;
        }
    });
    return found;
}

export const similarity = (s1, s2) => {
    var longer = s1;
    var shorter = s2;
    if (s1.length < s2.length) {
        longer = s2;
        shorter = s1;
    }
    var longerLength = longer.length;
    if (longerLength == 0) { // eslint-disable-line
        return 1.0;
    }
    return (longerLength - editDistance(longer, shorter)) / parseFloat(longerLength);
}

export const editDistance = (s1, s2) => {
    s1 = s1.toLowerCase();
    s2 = s2.toLowerCase();

    var costs = [];
    for (var i = 0; i <= s1.length; i++) {
        var lastValue = i;
        for (var j = 0; j <= s2.length; j++) {
            if (i == 0) // eslint-disable-line
                costs[j] = j;
            else {
                if (j > 0) {
                    var newValue = costs[j - 1];
                    if (s1.charAt(i - 1) != s2.charAt(j - 1)) // eslint-disable-line
                        newValue = Math.min(Math.min(newValue, lastValue),
                            costs[j]) + 1;
                    costs[j - 1] = lastValue;
                    lastValue = newValue;
                }
            }
        }
        if (i > 0)
            costs[s2.length] = lastValue;
    }
    return costs[s2.length];
}

export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}